export default {
	CPU: 'CPU',
	IP: 'IP',
	vps_console: {
		IP: 'IP',
		IPv4: 'IPv4',
		network_table: {
			'30_day': '最近30天',
			'7_day': '最近7天',
			to_day: '今天',
			to_month: '最近一個月',
		},
		'1个月': '1個月',
		'1年': '1年',
		'1小时': '1小時',
		'24小时': '24小時',
		'7天': '7天',
		百分比: '百分比',
		操作日志: '操作日誌',
		操作系统: '作業系統',
		操作已取消: '操作已取消',
		出带宽: '出帶寬',
		出站: '出站',
		创建时间: '創建時間',
		磁盘名称: '磁碟名稱',
		磁盘信息: '磁碟信息',
		等待重启: '等待重啟',
		读取速度: '讀取速度',
		读取IOPS: '讀取IOPS',
		断电关机: '斷電關機',
		发送流量: '發送流量',
		分钟: '分钟',
		复制: '複製',
		概览: '概覽',
		概要: '概要',
		格式化数据盘: '格式化資料盤',
		挂载: '掛載',
		关机: '關機',
		将重建至: '將重建至',
		接收流量: '接收流量',
		结束时间: '結束時間',
		进带宽: '進帶寬',
		进度: '進度',
		敬请期待: '敬請期待',
		开机: '開機',
		开始时间: '開始時間',
		控制台: '控制台',
		类型: '類型',
		类型大小: '類型大小',
		流出: '流出',
		流出流量: '流出流量',
		流量: '流量',
		流量计费统计: '流量計費統計',
		流入: '流入',
		流入流量: '流入流量',
		秒: '秒',
		内存用量: '記憶體用量',
		平均流量: '平均流量',
		'请求超时，请稍后刷新页面查看': '請稍後刷新頁面查看',
		请输入端口: '請輸入埠號',
		请输入密码: '請輸入密碼',
		请先确认数据已完成备份: '請先確認數據已完成備份',
		请选择操作系统: '請選擇作業系統',
		确定要断电关机吗: '確定要斷電關機嗎？',
		确定要关机吗: '確定要關機嗎？',
		确定要重启吗: '確定要重啟嗎？',
		任务: '任務',
		任务类型: '任務類型',
		任务描述: '任務描述',
		入站: '入站',
		实例ID: '實例ID',
		随机生成: '隨機產生',
		天: '天',
		图表: '圖表',
		网卡: '網卡',
		我确认数据已完成备份: '我確認數據已完成備份',
		系统重装中: '系統重裝中，請稍後重新整理頁面查看結果',
		小时: '小时',
		写入速度: '寫入速度',
		写入IOPS: '寫入IOPS',
		已持续运行: '已持续运行',
		已关机: '已关机',
		已用: '已用',
		硬盘IO: '硬碟IO',
		硬重启: '硬重啟',
		用户名密码: '用戶名密碼',
		远程: '遠程',
		运行中: '运行中',
		正在重置密码: '正在重置密碼',
		正在重装: '正在重裝',
		执行中: '执行中',
		重建实例: '重建實例',
		重建实例警告: '重建實例將清除所有個人數據，請確認您已經完成備份。您確定要重建此實例嗎?',
		重启: '重啟',
		重置密码: '重置密碼',
		重装: '重裝',
		重装系统将会导致系统盘数据丢失: '重裝系統將會清除系統盤所有資料，確認重裝？',
		重装系统确认: '重裝系統確認',
		主: '主',
		主机名: '主機名',
		总计流量: '總計流量',
		总量: '總量',
		最大流量: '最大流量',
		最新流量: '最新流量',
		CPU使用量: 'CPU使用量',
		IP地址: 'IP位址',
		SSH端口: 'SSH埠',
	},
	备注: '備註',
	本订单已有未处理的关闭申请工单号: '本訂單已有未處理的關閉申請 <strong>{no}</strong>',
	本订单已有未处理的售后工单工单号: '本訂單已有未處理的售後工單 <strong>{no}</strong>',
	操作: '操作',
	操作系统: '作業系統',
	产品: '產品',
	产品到期不续费: '（該產品已設定到期不續費，到期後產品將自動取消。）',
	产品到期续费: '（已允許手動續費，到期前將自動生成續費賬單。）',
	产品价格: '產品價格',
	产品配置: '產品配置',
	产品信息: '產品信息',
	产品选择: '產品選擇',
	带宽: '帶寬',
	单价: '單價',
	到期不续费: '到期不續費',
	到期日期: '到期日期',
	登录信息: '登錄信息',
	订单: '訂單',
	订单编号: '訂單編號',
	订单编号将于多少时间后关闭: '訂單 {no} 將於 {time} 後關閉',
	订单管理: '訂單管理',
	订单类型: '訂單類型',
	订单信息: '訂單信息',
	订单支付成功后将续费至日期: '訂單支付成功後將續費至 <strong>{date}</strong>',
	端口: '埠',
	发票信息: '發票資訊',
	返回: '返回',
	'服务器/cpu': '伺服器/cpu',
	附加IP地址: '附加IP位址',
	复制: '複製',
	复制信息: '複製信息',
	该产品需要实名认证达标后购买: '該產品需要實名認證達標後購買',
	个: '個',
	更多: '更多',
	购买物理机: '購買物理機',
	购买云主机: '購買雲主機',
	关闭订单: '關閉訂單',
	关闭订单标题: '訂單{no}關閉',
	关闭订单内容: '提交關閉訂單，編號{no}，產品{product}，訂單到期日期{date}',
	关闭原因必填: '請填寫關閉原因',
	关闭原因占位: '說明關閉原因，例如：不再需要、遷移到其他服務等',
	核心: 'Core',
	恢复续费账单: '恢復續費賬單',
	机房: '機房',
	'机房/线路': '機房/線路',
	计费: '計費',
	计价周期: '計價周期',
	价格: '價格',
	开通日期: '開通日期',
	'开通日期/到期日期': '開通日期/到期日期',
	'开通日期/结束日期': '開通日期/結束日期',
	可选产品: '可選產品',
	可选线路: '可選線路',
	控制台: '控制臺',
	库存: '庫存',
	库存不足无法下单: '庫存不足，無法下單',
	类型: '類型',
	历史订单: '歷史訂單',
	密码: '密碼',
	名称: '名稱',
	默认带宽: '預設帶寬',
	默认内存: '預設內存',
	默认区域: '預設區域',
	默认数据盘: '預設數據盤',
	默认系统盘: '預設系統盤',
	默认CPU: '預設vCPU',
	默认IP数量: '預設IP數量',
	内存: '內存',
	配置: '配置',
	处理中: '處理中',
	请填写关闭原因: '請填寫關閉原因，業務員收到後會與您聯繫處理',
	请至少改变一个配置: '請至少改變一個配置',
	区域: '區域',
	取消: '取消',
	缺货: '缺貨',
	确认关闭编号为编号的订单: '確認關閉編號為<strong>{no}</strong>的訂單?',
	确认关闭订单提示: '確認提交關閉訂單 <strong>{no}</strong> 的申請？業務員收到後會與您聯繫處理。',
	'确认要到期不续费吗？': '確認要到期不續費嗎？',
	'确认要恢复续费账单吗？': '確認要恢復續費賬單嗎？',
	申请已提交工单号: '工單已提交，工單號 <strong>{no}</strong>',
	升级配置: '升級配置',
	生成发票: '續費',
	剩余: '剩餘',
	试用开通日期: '試用開通日期',
	试用中: '試用中',
	输入订单编号查询: '輸入訂單編號查詢',
	数据盘: '數據盤',
	刷新: '刷新',
	提交订单: '提交訂單',
	提示: '提示',
	网络: '網絡',
	未关联主机: '未關聯主機',
	系统盘: '系統盤',
	下单时间: '下單時間',
	线路: '線路',
	线路带宽: '線路帶寬',
	详情: '詳情',
	修改配置后生成: '修改配置後生成',
	已启用: '已啟用',
	已失效: '已失效',
	已停用: '已停用',
	硬盘: '硬碟',
	用户名: '用戶名',
	远程端口: '遠程埠',
	月: '月',
	暂无可用线路: '暫無可用線路',
	支付: '支付帳單',
	支付补差价: '支付補差價',
	重置配置: '重置配置',
	主机名: '主機名',
	主机信息: '主機信息',
	状态: '狀態',
	字段不能小于原配置: '{field}不能小於原配置',
	自定义: '自定義',
	自动生成: '自動生成',
	自动续费: '自動續費',
	总计: '總計',
	IP地址: 'IP位址',
	IP配置: 'IP配置',
	IP数量: 'IP數量',
	IP数量限制: 'IP數量限制',
	MAC地址: 'MAC地址',
	VPS信息: 'VPS資訊',
}
